/**
 * Wishlist Hero list cards: turn CardMedia background-image into a real <img>
 * and keep every card on the same gray fill.
 */
(function () {
  var SELECTOR = '#MainContent #__next .wishlist-hero-list-card-product-image';
  var CARD_SELECTOR = '#MainContent #__next .wishlist-hero-list-card .MuiCard-root, #MainContent #__next .wishlist-hero-list-card .MuiPaper-root';
  var CARD_BG = 'rgba(204, 204, 204, 0.6)';

  function extractBgUrl(el) {
    var bg = el.style.backgroundImage || '';
    if (!bg || bg === 'none') {
      try {
        bg = window.getComputedStyle(el).backgroundImage || '';
      } catch (e) {
        bg = '';
      }
    }
    var match = bg.match(/url\(\s*["']?([^"')]+)["']?\s*\)/i);
    return match ? match[1] : '';
  }

  function paintCard(el) {
    if (!el) return;
    el.style.setProperty('background', CARD_BG, 'important');
    el.style.setProperty('background-color', CARD_BG, 'important');
    el.style.setProperty('background-image', 'none', 'important');
  }

  function paintAllCards(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = scope.querySelectorAll ? scope.querySelectorAll(CARD_SELECTOR) : [];
    Array.prototype.forEach.call(cards, paintCard);
  }

  function convertMedia(el) {
    if (!el || el.dataset.wlhImgConverted === '1') return;

    var existing = el.querySelector('img.wishlist-hero-list-card-product-img');
    var src = extractBgUrl(el);

    if (!src && existing) {
      el.style.setProperty('background', 'transparent', 'important');
      el.style.setProperty('background-image', 'none', 'important');
      el.dataset.wlhImgConverted = '1';
      return;
    }

    if (!src) return;

    if (!existing) {
      var img = document.createElement('img');
      img.className = 'wishlist-hero-list-card-product-img';
      img.src = src;
      img.alt = el.getAttribute('title') || el.getAttribute('aria-label') || '';
      img.loading = 'lazy';
      img.decoding = 'async';
      el.appendChild(img);
    } else if (existing.src !== src) {
      existing.src = src;
    }

    el.style.setProperty('background', 'transparent', 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.dataset.wlhImgConverted = '1';
  }

  function convertAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes =
      scope.matches && scope.matches(SELECTOR)
        ? [scope]
        : scope.querySelectorAll
          ? scope.querySelectorAll(SELECTOR)
          : [];

    Array.prototype.forEach.call(nodes, convertMedia);
    paintAllCards(scope);
  }

  function init() {
    convertAll(document);

    var main = document.getElementById('MainContent');
    if (!main || typeof MutationObserver === 'undefined') return;

    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        convertAll(document);
      }, 50);
    });

    observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
